module.exports = __webpack_public_path__ + "img/symbol_3.f0e142a6.png";